module.exports = __webpack_public_path__ + "img/code.16adb883.jpg";